// Theme → asset mapping. Owned by docs/asset-naming.md#theme-mapping.
// Seam #10 — owner: Client.
//
// Theme 3 intentionally shares ingredients with theme 0 (same product, different package).
// Don't "fix" the duplicate.

import type { Theme } from "../state/types";

export const INGREDIENTS_BY_THEME: Record<Theme, number[]> = {
  0: [0, 1, 2, 3],
  1: [0, 1, 3, 4],
  2: [2, 3, 4, 5],
  3: [0, 1, 2, 3],
  4: [0, 2, 3, 6],
};

export const HAZARD_INDICES = [0, 1, 2, 3]; // theme-agnostic

export function backgroundName(theme: Theme): string {
  return `bg_${theme}.png`;
}

export function cupName(theme: Theme): string {
  return `body_cup_${theme}.png`;
}

/** The cup the character HOLDS in the composite — the FE-static "_A" art (open
 *  cup with noodles + spoon), as opposed to cupName()'s closed product shot used
 *  for the ChooseCup selection tile. FE-static (not BE /v1/shared), so this is a
 *  full same-origin path. Used by the game render + every character preview. */
export function cupCompositeUrl(theme: Theme): string {
  return `/textures/flow/body_cup_${theme}_A.png`;
}

export function ingredientName(i: number): string {
  return `ingredient_${i}.png`;
}

export function hazardName(i: number): string {
  return `hazard_${i}.png`;
}
